import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Material from '@/components/Material'
import CodeInput from '@/components/CodeInput'
import Mdf from '@/components/Mdf'

Vue.use(Router)

const $ = require('jquery')
const contextPath = $("body").attr("contextPath")
let debug = false;
debug = ($("body").attr("debug") == 'true');

export default new Router({
  routes: [
    /* 本番では /v/select, re-selectのみ */
/*      
      
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: contextPath+'/v',
      name: 'Material',
      component: Material
    },
*/
    {
	path: contextPath+'/v/material',
	name: 'Material',
	component: Material
    },
    {
	path: contextPath+'/v/codeInput',
	name: 'CodeInput',
	component: CodeInput,
	props: { debug: debug }
    },
    {
	path: contextPath+'/v/codeInput-b',
	name: 'CodeInput',
	component: CodeInput,
	props: { debug: debug,
		 session: true
	       }
    },
    {
	path: contextPath+'/v/d-codeInput',
	name: 'CodeInput',
	component: CodeInput,
	props: { debug: true }
    },
    {
	path: contextPath+'/v/select/:id',
	name: 'Mdf',
	component: Mdf,
	props: {reSelect: false}
	/* props: (route) => ({
	    h: route.query.h,
	    reSelect: false
	}) */
    },
    {
	path: contextPath+'/v/re-select/:id',
	// name: 'Mdf',
	component: Mdf,
	props: {reSelect: true}
    },
    /*{
	path: '/sel',
	name: 'Mdf',
	component: Mdf
	}, */
    //{ path: '*', componnet: Material }
  ],
    mode: 'history',
    /*
    scrollBehavior: function(to, from, savedPosition) {
	if(to.hash) {
	    return { selector: to.hash }
	} else {
	    return { x: 0, y: 0 }
	}
    } */
})



// WEBPACK FOOTER //
// ./src/router/index.js